module.exports = __webpack_public_path__ + "img/app-store.f3e8f9be.png";